module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ListCage table9"
  }, [_c('div', {
    staticClass: "tabTtl"
  }, [(_vm.pressType == 1) ? _c('span', [_vm._v("表 2-1：音像制品出版情况登记表")]) : _c('span', [_vm._v("表 2-1：电子出版物出版情况登记表")]), _vm._v(" "), _c('div', {
    staticClass: "tabBtns"
  }, [_c('el-button', {
    staticStyle: {
      "width": "130px"
    },
    attrs: {
      "type": "primary",
      "size": "mini"
    },
    on: {
      "click": _vm.pullProductFromSystem
    }
  }, [_vm._v("音电书号系统导入")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "javascript:void(0);",
      "download": ""
    },
    on: {
      "click": function($event) {
        _vm.dmyfile(1)
      }
    }
  }, [_c('el-button', {
    attrs: {
      "size": "mini",
      "type": "primary"
    }
  }, [_vm._v("导出Excel")])], 1), _vm._v(" "), _c('el-button', {
    attrs: {
      "size": "mini"
    },
    on: {
      "click": _vm.goBack
    }
  }, [_vm._v("返回")]), _vm._v(" "), _c('ExcelIn', {
    ref: "ExcelSet",
    attrs: {
      "pressId": _vm.querys.pressId,
      "mtId": _vm.querys.mtId,
      "excelCode": "301",
      "pressType": _vm.pressType
    },
    on: {
      "t-frash": _vm.goFresh,
      "excel-errors": _vm.errorCtrls
    }
  })], 1)]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "ctrlsLine"
  }, [_c('el-radio-group', {
    on: {
      "change": _vm.tabSeek
    },
    model: {
      value: (_vm.yearSet),
      callback: function($$v) {
        _vm.yearSet = $$v
      },
      expression: "yearSet"
    }
  }, [_c('el-radio', {
    attrs: {
      "label": 0
    }
  }, [_vm._v("全部")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": 1
    }
  }, [_vm._v(_vm._s(_vm.selYear - 2) + "年")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": 2
    }
  }, [_vm._v(_vm._s(_vm.selYear - 1) + "年")])], 1), _vm._v(" "), _c('el-input', {
    attrs: {
      "size": "small",
      "placeholder": "通过出版物名称、专用书号查询"
    },
    model: {
      value: (_vm.seekPms.keyword),
      callback: function($$v) {
        _vm.$set(_vm.seekPms, "keyword", $$v)
      },
      expression: "seekPms.keyword"
    }
  }), _vm._v(" "), _c('el-button', {
    staticClass: "seekBtn",
    attrs: {
      "size": "small"
    },
    on: {
      "click": function($event) {
        _vm.tabSeek('init')
      }
    }
  }, [_vm._v("查询")])], 1), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "tabArea"
  }, [_c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.filterData(_vm.tabDat, _vm.seekPms).slice((_vm.currentPage - 1) * _vm.pageSize, _vm.currentPage * _vm.pageSize),
      "border": ""
    },
    on: {
      "selection-change": _vm.selectionChange
    }
  }, [_c('el-table-column', {
    attrs: {
      "type": "selection",
      "width": "45"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "序号",
      "width": "60",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n          " + _vm._s(scope.$index + 1 + 20 * (_vm.currentPage - 1)) + "\n        ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "year",
      "label": "年份",
      "width": "90",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "publicationName",
      "label": "出版物名称",
      "width": "180",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "isbn",
      "width": "150",
      "label": "专用书号(ISBN 978-7-)",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "载体形式",
      "width": "90",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(_vm.pressType == 1) ? _c('div', [_vm._v("\n            " + _vm._s(_vm._f("translate")(scope.row.carrierForm, "C010", _vm.dicMap, scope.row)) + "\n          ")]) : (_vm.pressType == 2) ? _c('div', [_vm._v("\n            " + _vm._s(_vm._f("translate")(scope.row.carrierForm, "C025", _vm.dicMap, scope.row)) + "\n          ")]) : _vm._e()]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "出版形式",
      "width": "90",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n          " + _vm._s(_vm._f("translate")(scope.row.publicationForm, "C011", _vm.dicMap)) + "\n        ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "productionUnit",
      "label": "节目来源/制作单位",
      "width": "120",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "programCapacity",
      "label": "节目时长或容量(分钟/兆)",
      "width": "90",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "publicationQuantity",
      "label": "出版数量（张/盒）",
      "width": "90",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "publishingTime",
      "label": "出版时间",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n          " + _vm._s(_vm._f("stringTrans")(scope.row.publishingTime, "time")) + "\n        ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "是否书配盘标记",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n          " + _vm._s(_vm._f("translate")(scope.row.sign, "C018", _vm.dicMap)) + "\n        ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "操作",
      "width": "150",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "type": "primary",
            "size": "mini"
          },
          on: {
            "click": function($event) {
              _vm.memberEdit(2, scope.row)
            }
          }
        }, [_vm._v("编辑")])]
      }
    }])
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "pageArea"
  }, [(_vm.allPage > 1) ? _c('el-pagination', {
    attrs: {
      "layout": "prev, pager, next",
      "current-page": _vm.seekPms.no,
      "page-count": _vm.allPage
    },
    on: {
      "current-change": _vm.goPage
    }
  }) : _vm._e()], 1), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "editArea newEditArea"
  }, [_c('div', {
    staticClass: "editBox"
  }, [_c('p', {
    staticClass: "edName"
  }, [_vm._v("申报人：")]), _vm._v(" "), _c('div', {
    staticClass: "edInp"
  }, [_c('el-input', {
    attrs: {
      "size": "small",
      "placeholder": "请输入申报人"
    },
    model: {
      value: (_vm.declare.personnel),
      callback: function($$v) {
        _vm.$set(_vm.declare, "personnel", $$v)
      },
      expression: "declare.personnel"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "editBox"
  }, [_c('p', {
    staticClass: "edName"
  }, [_vm._v("联系方式：")]), _vm._v(" "), _c('div', {
    staticClass: "edInp"
  }, [_c('el-input', {
    attrs: {
      "size": "small",
      "placeholder": "请输入申报人联系方式"
    },
    model: {
      value: (_vm.declare.contact),
      callback: function($$v) {
        _vm.$set(_vm.declare, "contact", $$v)
      },
      expression: "declare.contact"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "editBox"
  }, [_c('p', {
    staticClass: "edName"
  }, [_vm._v("申报时间：")]), _vm._v(" "), _c('div', {
    staticClass: "edInp"
  }, [_c('el-input', {
    attrs: {
      "size": "small",
      "disabled": true
    },
    model: {
      value: (_vm.updatedAt),
      callback: function($$v) {
        _vm.updatedAt = $$v
      },
      expression: "updatedAt"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "saveBtn"
  }, [_c('el-button', {
    attrs: {
      "size": "small"
    },
    on: {
      "click": _vm.goBack
    }
  }, [_vm._v("返回")]), _vm._v(" "), (_vm.pubStatus == 0) ? _c('el-button', {
    attrs: {
      "type": "primary",
      "size": "small"
    },
    on: {
      "click": _vm.postDeclareFun
    }
  }, [_vm._v("保存")]) : _vm._e()], 1)]), _vm._v(" "), _c('ExError', {
    ref: "chinldError",
    attrs: {
      "errorList": _vm.excelEr,
      "pressCode": "301"
    }
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tip-div"
  }, [_c('span', {
    staticClass: "tip-red"
  }, [_vm._v("工作提醒：本系统为非涉密信息系统，请严格遵守相关保密工作规定，切勿上传任何涉密信息及文件。")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "table_tips"
  }, [_c('p', [_vm._v("注：此表内容只能从书号系统同步数据，规则为成品上传时间在两个核验年度中的全部出版物信息。")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "headBar"
  }, [_c('span', [_vm._v("申报人信息")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-356486bc"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/pressRole/Audio_Electronic/forTabs/table9.vue
// module id = 1705
// module chunks = 1